import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"

import Divider from "@material-ui/core/Divider"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import ListItemText from "@material-ui/core/ListItemText"
import ListItemIcon from "@material-ui/core/ListItemIcon"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { Box, Button, Hidden } from "@material-ui/core"
import Grid from "@material-ui/core/Grid"

import pageNaming from "../../utilities/pageNaming"

import { Link } from "gatsby"

import { LangSelector, CartButton } from ".."

// import Logo from "../../images/logo.jpg"
import MenuIcon from "../../images/menu-mobile-icon.svg"
import CloseIcon from "../../images/close-menu-mobile.svg"
import NavArrow from "../../images/navigation-arrow.svg"

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: theme.spacing(13),
    width: "100%",
    backgroundColor: "white",
    position: "relative",
    paddingBottom: theme.spacing(1.5),
    justifyContent: "space-between",
    zIndex: 1,
  },

  logoImage: {
    position: "relative",
    width: theme.spacing(7.5),
    left: "50%",
    transform: "translate(-50%)",
    paddingTop: theme.spacing(1),
  },
  shoppingBagDiv: {
    position: "relative",
    float: "right",
  },
  shoppingBagImage: {
    position: "relative",
    width: "32px",
    height: "32px",
  },
  menu: {
    position: "relative",
  },
  button: {
    marginBottom: theme.spacing(0.5),
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  listIcon: {
    position: "relative",
    width: "16px",
    height: "16px",
    bottom: "2px",
    marginLeft: "8px",
  },
  listText: {
    display: "inline",
    flex: "none",
    marginLeft: theme.spacing(3),
    letterSpacing: "1px",
  },
  listItem: {
    padding: "0px",
    marginTop: theme.spacing(5),
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  subListItem: {
    padding: "0px",
    marginTop: theme.spacing(4),
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  link: {
    textDecoration: "none",
    color: "black",
    whiteSpace: "nowrap",
  },
  drawer: {
    backgroundColor: "white",
    position: "absolute",
    width: "100vw",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
  },

  subDrawer: {
    display: "block",
    flexGrow: 1,
  },
  backArrow: {
    display: "block",
    "&:hover": {
      backgroundColor: "transparent",
    },
    transform: "rotate(180deg) scale(.65)",
    padding: "0px",
    marginTop: theme.spacing(4.1),
  },
  selectedItem: {
    margin: theme.spacing(4, 0, 0, 3),
    fontFamily: theme.typography.button.fontFamily,
    fontSize: theme.spacing(2.25),
    color: theme.palette.tertiary.light,
  },

  footer: {
    position: "fixed",
    width: "100%",
    bottom: "0px",
    paddingLeft: theme.spacing(3),
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  newsLetter: {
    position: "relative",
    fontFamily: theme.typography.button.fontFamily,
    fontWeight: "0",
    fontSize: theme.spacing(1.8),
    textDecoration: "none",
    top: "6px",
    color: "black",
    marginRight: theme.spacing(4),
  },
  divider: {
    marginBottom: theme.spacing(2),
  },
}))

var selectedItem
var subMenuList = []
const capitalize = str => {
  str = str.split(" ")

  for (let i = 0, x = str.length; i < x; i++) {
    str[i] = str[i][0].toUpperCase() + str[i].substr(1)
  }
  return str.join(" ")
}

export default injectIntl(props => {
  const classes = useStyles()
  const theme = useTheme()
  const Logo = props.data.mainLogo.file.url
  const [mobileOpen, setMobileOpen] = React.useState(false)
  const [subMenuOpen, setSubMenuOpen] = React.useState(false)
  const localeConsts = require("../../constants/localeConsts")

  const handleBackButton = () => {
    setSubMenuOpen(!subMenuOpen)
  }

  function handleDrawerToggle() {
    setMobileOpen(!mobileOpen)
  }

  const handleClick = item => () => {
    subMenuList = [props.items[item], item]
    selectedItem = capitalize(item.toLowerCase())
    let toggleSubmenu = !subMenuOpen
    if (props.items[item].length < 1) {
      toggleSubmenu = false
      handleDrawerToggle()
    }
    setSubMenuOpen(toggleSubmenu)
  }

  return (
    <div>
      <Box className={classes.root}>
        <Grid container direction="row" alignItems="center">
          <Grid item xs={4}>
            {!mobileOpen ? (
              <div className={classes.menu}>
                <Button className={classes.button} onClick={handleDrawerToggle}>
                  <img src={MenuIcon} data-cy="menu" alt="Menu" />
                </Button>
              </div>
            ) : (
              <div className={classes.menu}>
                <Button className={classes.button} onClick={handleDrawerToggle}>
                  <img src={CloseIcon} data-cy="close-menu" alt="Close Menu" />
                </Button>
              </div>
            )}
          </Grid>
          <Grid item xs={4}>
            <Link to={`/${props.intl.locale}`}>
              <div justify="center">
                <img
                  src={Logo}
                  className={classes.logoImage}
                  data-cy="header-logo"
                  alt="Logo"
                />
              </div>
            </Link>
          </Grid>
          {props.intl.locale === localeConsts.es &&
          <Grid item xs={4}>
            <div className={classes.shoppingBagDiv}>
              <CartButton
                cartLogo={props.data.shoppingCartLogo.file.url}
                onClick={props.cartToggle}
              />
            </div>
          </Grid>}
        </Grid>
      </Box>
      {mobileOpen && (
        <div className={classes.drawer}>
          <Divider className={classes.divider} />
          <div>
            {!subMenuOpen && (
              <div className={classes.subDrawer}>
                <List>
                  {Object.keys(props.items).map(item => {
                    let pageName =
                      item === "localizador de tiendas" ||
                      item === "store locator"
                        ? "store locator"
                        : item
                    return props.items[item].length < 1 ? (
                      <Link
                        className={classes.link}
                        to={`/${props.intl.locale}/${pageNaming(pageName)}`}
                        key={item}
                      >
                        <ListItem
                          button
                          onClick={handleClick(item)}
                          className={classes.listItem}
                        >
                          <ListItemText
                            className={classes.listText}
                            primary={item.toUpperCase()}
                            primaryTypographyProps={{ variant: "button" }}
                          />
                        </ListItem>
                      </Link>
                    ) : (
                      <ListItem
                        button
                        key={item}
                        onClick={handleClick(item)}
                        className={classes.listItem}
                      >
                        <ListItemText
                          className={classes.listText}
                          primary={item.toUpperCase()}
                          primaryTypographyProps={{ variant: "button" }}
                        />
                        <ListItemIcon className={classes.listIcon}>
                          <img src={NavArrow} alt="Navigation Arrow" />
                        </ListItemIcon>
                      </ListItem>
                    )
                  })}
                </List>
              </div>
            )}
            {subMenuOpen && (
              <div className={classes.subDrawer}>
                <Button
                  className={classes.backArrow}
                  onClick={handleBackButton}
                >
                  <img src={NavArrow} alt="Back Arrow" />
                </Button>
                <div className={classes.selectedItem}>{selectedItem}</div>
                <List>
                  {subMenuList[1] === "our products" ||
                  subMenuList[1] === "nuestros productos"
                    ? subMenuList[0].map(item => (
                        <ListItem
                          button
                          key={item[0]}
                          className={classes.subListItem}
                        >
                          <Link
                            to={`/${props.intl.locale}/line/${pageNaming(
                              item[1]
                            )}-${
                              props.intl.locale === localeConsts.es
                                ? "es"
                                : "en"
                            }`}
                            className={classes.link}
                          >
                            <ListItemText
                              className={classes.listText}
                              primaryTypographyProps={{ variant: "button" }}
                              primary={item[0].toUpperCase()}
                            />
                          </Link>
                          <ListItemIcon className={classes.listIcon}>
                            <img src={NavArrow} alt="Navigation Arrow" />
                          </ListItemIcon>
                        </ListItem>
                      ))
                    : subMenuList[0].map(item => (
                        <ListItem
                          button
                          key={item[0]}
                          className={classes.subListItem}
                        >
                          <Link
                            to={`/${props.intl.locale}/${pageNaming(item[1])}`}
                            className={classes.link}
                          >
                            <ListItemText
                              className={classes.listText}
                              primaryTypographyProps={{ variant: "button" }}
                              primary={item[0].toUpperCase()}
                            />
                          </Link>
                          <ListItemIcon className={classes.listIcon}>
                            <img src={NavArrow} alt="Navigation Arrow" />
                          </ListItemIcon>
                        </ListItem>
                      ))}
                </List>
              </div>
            )}
            <div className={classes.footer}>
              <Hidden lgDown>
                <Link className={classes.newsLetter} to="/">
                  <FormattedMessage id="newsletter" />
                </Link>
              </Hidden>
              {/*<LangSelector
                mobile={true}
                fontSize={theme.spacing(2.2)}
                marginRight={theme.spacing(3.5)}
                slug={props.slug}
                response={props.response}
              />*/}
            </div>
          </div>
        </div>
      )}
    </div>
  )
})
